import { AppState } from "@teamprevent/common/customerSraDepartment/model";

import { ADMIN_ROLES } from "../../auth";
import { CustomerState } from "../customer";

import { detailRoutes } from "./detailRoutes";
import { customerSraDepartmentSelector } from "./selectors";

const detailRoute = () => ({
    "/:customerSraDepartmentId": {
        title: (state: AppState & CustomerState) => customerSraDepartmentSelector(state).name || "SRA Department",
        "/edit": {
            title: "Edit",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        },
        ...detailRoutes
    }
});

export const childRoutes = (titleFunc: (state: any) => string) => {
    return {
        "/customerSraDepartments": {
            title: (state: AppState) => titleFunc(state) ? titleFunc(state) + " SRA Departments" : "SRA Departments",
            ...detailRoute(),
            "/create": {
                title: "Create SRA Department",
                authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
            }
        }
    };
};
